import { Box, useMediaQuery, Grid } from "@mui/material";
import { sectionWrapperSx } from "./sectionWrapper";
import { settings } from "app";
import PreferencesTab from "features/PreferencesTab";
import { PreferenceOrigin } from "utils/constants"

const Preferences = ({ record, isForeigner }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Box sx={sectionWrapperSx}>
      <Grid
        container
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <PreferencesTab
            record={record}
            isForeigner={isForeigner}
            handleKey={PreferenceOrigin.Student}
          />
        </Grid>
      </Grid> 
    </Box>
  );
};

export default Preferences;
